import { render, staticRenderFns } from "./EnacAtplDashboardItemLearnerTopBox.vue?vue&type=template&id=1ff11002"
import script from "./EnacAtplDashboardItemLearnerTopBox.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardItemLearnerTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports